export const en = {
    nav_home: "Home",
    nav_tools: "Tools",
    nav_intelligence: "Intelligence",
    nav_about: "About Us",
    nav_contact: "Contact Us",
    nav_premium: "Premium",
    hero_title: "Blunt, Private, and High-Performance Online Tools",
    hero_subtitle: "We're tired of bloatware. Access localized, browser-native utilities for PDF, text, and JSON without the 'cloud' middleman. 100% private, 100% local, and zero tracking.",
    footer_tagline: "A trusted collection of free online tools for everyday tasks",
    footer_why_title: "Why Choose This Toolset?",
    footer_why_desc: "We’re not interested in your data. Honestly, it’s a liability we aren't willing to take on. That’s why we engineered this whole toolset to run 100% locally in your own browser. No server-side uploads, no data-mining, and no 'accidental' leaks. If it never leaves your machine, it stays your business not ours.",
    footer_features_title: "Key Features",
    footer_feature_1: "Your data never leaves your machine. Period. We’ve removed the middleman so there's literally no way for us to see, store, or leak your files.",
    footer_feature_2: "Pure, browser-native speed. We’ve optimized the logic to run directly on your hardware no cloud delays and no processing lag.",
    footer_feature_3: "Runs on everything. Desktop, tablet, or phone you get the same high-performance toolkit without needing to install a single thing.",
    footer_feature_4: "Actually free. No accounts, no paywalls, and no hidden garbage. Just open access to the tools you need to get your work done.",
    select_language: "Select Language",
    all_tools: "All Tools",
    utility_tools: "Utility Tools",
    stay_updated: "Stay Updated",
    subscribe_desc: "Get notified about new tools and privacy updates. No spam, ever.",
    enter_email: "Enter your email",
    subscribe_btn: "Subscribe",
    text_utilities: "Text Utilities",
    privacy_pdf: "Privacy & PDF",
    cleaning_tools: "Cleaning Tools",
    platform: "Platform",
    copyright: "CorpToolset Global Ecosystem. Zero-Knowledge Local Execution Standards.",
    trusted_by: "Our tools and products are trusted by 10,000+ teams worldwide",
    custom_software_title: "Need Custom Software or a Professional Website?",
    custom_software_desc: "Most off-the-shelf apps are full of stuff you will never use. We prefer to look at what is actually slowing your business down today and then we write a program to stop it from happening again. It runs fast and belongs to you.",
    service_software_title: "Custom Software Development",
    service_software_desc: "Buying monthly subscriptions for tools that only do half of what you want is a waste of money. We build single-purpose software that does exactly what you need it to do, and nothing else. You own it, it runs fast, and you never have to pay rent on your own workflow.",
    service_web_title: "Enterprise Web Solutions",
    service_web_desc: "A slow website literally costs you money every second it takes to load. We build sites that load instantly and rank at the top of Google. We don't just make things look pretty; we make sure your visitors can actually find you and buy from you without getting frustrated.",
    service_end_title: "End-to-End Service",
    service_end_desc: "Our team does not employ account managers. Every conversation you have is with the programmer building your site. They handle the messy server setup and deployment parts so your team can focus on actually running the business.",
    years_exp: "Years Experience",
    satisfied_clients: "Satisfied Clients",
    service_delivery: "Service Delivery",
    client_reviews: "Client Reviews",
    project_mind: "Have a Project in Mind?",
    project_desc: "Contact us today to discuss your requirements and get a professional solution.",
    get_quote: "Get a Free Quote",
    email_us: "OR EMAIL US DIRECTLY AT",
    text_cleaning_cat: "Text Formatting & Cleaning",
    extraction_cat: "Extraction & Analysis",
    data_code_cat: "Data & Code Utilities",
    gen_pdf_cat: "Generators & PDF",
    explore_ecosystem: "Browse All Available Tools",
    home_number_one: "The #1 Home for Free Online Tools in 2026",
    platform_mission: "CorpToolset isn't another generic 'free tools' site. We're an engineering-first collective building high-performance utilities that respect your hardware. By forcing 100% of the processing to happen in your browser, we've eliminated the need for trust. If we can't see your data, we can't compromise it. It's that simple.",
    sort_text_title: "Sort Text Online",
    sort_text_desc: "Alphabetical and natural list sorting for messy data sets.",
    word_counter_title: "Word Counter",
    word_counter_desc: "Get word, character, and sentence counts with accuracy.",
    diff_checker_title: "Diff Checker",
    diff_checker_desc: "Compare two text blocks side-by-side to find differences.",
    json_formatter_title: "JSON Formatter",
    json_formatter_desc: "Beautify, minify, and validate JSON code with ease.",
    pdf_merge_title: "Merge PDF",
    pdf_merge_desc: "Combine multiple PDF files into one document securely.",
    grammar_checker_title: "Grammar Checker",
    grammar_checker_desc: "Fix spelling and grammar errors for better writing.",
    view_all: "View All",
    latest_blog: "Latest Insights",
    browse_all: "Browse All Articles",
    privacy_policy: "Privacy Policy",
    terms_service: "Terms of Service",
    disclaimer: "Disclaimer",
    nav_faq: "FAQ",
    sitemap: "Sitemap",
    find_replace_title: "Find and Replace",
    find_replace_desc: "Search and replace multiple strings across large documents instantly.",
    duplicate_remover_title: "Duplicate Remover",
    duplicate_remover_desc: "Clean up lists by deleting identical lines automatically.",
    email_extractor_title: "Email Extractor",
    email_extractor_desc: "Extract all email addresses from unstructured text blocks.",
    random_string_title: "Random String Gen",
    random_string_desc: "Generate secure, randomized text strings for passwords or keys.",
    pdf_split_title: "Split PDF",
    pdf_split_desc: "Divide PDFs into smaller parts or extract single pages.",
    case_converter_title: "Case Converter",
    case_converter_desc: "Switch between UPPERCASE, lowercase, and Title Case.",
    html_stripper_title: "HTML Stripper",
    html_stripper_desc: "Clean HTML tags from text to get pure, readable content.",
    emoji_remover_title: "Emoji Remover",
    emoji_remover_desc: "Strip all emojis and Unicode icons from your messages.",
    url_extractor_title: "URL Extractor",
    url_extractor_desc: "Find and list all web links hidden in your text documents.",
    username_gen_title: "Username Gen",
    username_gen_desc: "Create unique, catchy usernames for social and games.",
    password_gen_title: "Password Gen",
    password_gen_desc: "Generate ultra-secure, cryptographically strong passwords.",
    prefix_suffix_title: "Prefix & Suffix",
    prefix_suffix_desc: "Batch add text to the beginning or end of every line.",
    line_break_title: "Line Break Tool",
    line_break_desc: "Add or remove line breaks to format your text perfectly.",
    reverse_words_title: "Reverse Words",
    reverse_words_desc: "Flip the order of words in each sentence instantly.",
    random_number_title: "Random Number",
    random_number_desc: "Pick random numbers within your custom-defined range.",
    generate_btn: "Generate",
    copy_btn: "Copy to Clipboard",
    enter_topic: "Enter your topic or keywords",
    select_tool_label: "Select Category",
    optimized_prompt: "Your Optimized Prompt",
    faq_is_it_free: "Is this tool really free?",
    gst_calc_title: "GST Calculator India",
    gst_calc_desc: "Tax compliance isn't a suggestion; it's a requirement. We've built this GST calculator to strip away the complexity of Indian fiscal regulations. Whether you're running corporate payroll or auditing liabilities, there's zero room for error. This isn't a generic web app it's an high-performance engine designed for 100% mathematical certainty, running entirely on your local hardware.",
    emi_calc_title: "EMI Calculator",
    emi_calc_desc: "Loan planning shouldn't be a guessing game. Use this EMI calculator to get exact repayment figures. No cloud processing just pure local math to keep your financial planning private.",
    loan_calc_title: "Loan Calculator",
    loan_calc_desc: "Understand the truth behind bank interest rates. We built this loan calculator to analyze your loan structure with zero data sharing.",
    salary_calc_title: "Salary Calculator",
    salary_calc_desc: "Your CTC is not your take-home pay. Use this salary calculator to immediately see what hits your bank account each month, processed securely in your own browser.",
    tax_calc_title: "Income Tax Calculator",
    tax_calc_desc: "Estimate your tax liability for FY 24-25 under New Regime.",
    profit_calc_title: "Profit Margin Calculator",
    profit_calc_desc: "Calculate gross/net profit and margins for your products.",
    discount_calc_title: "Discount Calculator",
    discount_calc_desc: "Find final prices and total savings during sales events.",
    perc_calc_title: "Percentage Calculator",
    perc_calc_desc: "Solve any percentage-based math problem in seconds.",
    age_calc_title: "Age Calculator",
    age_calc_desc: "Find your exact chronological age in years, months, and days.",
    duration_calc_title: "Duration Calculator",
    duration_calc_desc: "Measure exact time span between two dates and timestamps.",
    invoice_gen_title: "Invoice Generator",
    invoice_gen_desc: "Create professional, tax-compliant invoices for your clients.",
    quotation_gen_title: "Quotation Generator",
    quotation_gen_desc: "Generate high-impact business estimates and proposals.",
    bill_gen_title: "Bill Generator",
    bill_gen_desc: "Quickly create simple bills and receipts for any transaction.",
    gst_format_title: "GST Invoice Tool",
    gst_format_desc: "Compliant Indian GST billing with HSN/SAC code support.",
    expense_track_title: "Expense Tracker",
    expense_track_desc: "Secure, 100% private logging of your business outgoings.",
    ai_prompt_title: "AI Prompt Generator",
    ai_prompt_desc: "Optimize your LLM prompts for better results with GPT-4 and Claude.",
    contact_title: "Contact Us",
    contact_desc: "We are an independent group of engineers architecting the exact high-precision tools required for our own internal workflows. Address all technical audits regarding our client-native architecture or data confidentiality protocols via the transmission portal below. We maintain a high-frequency response throughput, typically resolving standard inquiries within a 24-hour business window.",
    contact_copyright_title: "Copyright and Content Concerns",
    contact_copyright_desc: "If you are a content owner and have concerns regarding any material available on this Website, please contact our legal department at legal@corptoolset.com.",
    contact_tech_support_title: "Technical Audit & Bug Reporting",
    contact_tech_support_desc: "For critical system deviations or unexpected UI behavior, provide a granular technical breakdown to accelerate our internal debugging protocols:",
    contact_tech_support_item1: "Your operating system and CPU architecture",
    contact_tech_support_item2: "The specific browser and version you are running",
    contact_tech_support_item3: "Step-by-step Reproduction (Logical flow leading to error)",
    contact_form_title: "Contact Form",
    contact_name_label: "Full Name",
    contact_email_label: "Email Address",
    contact_subject_label: "Subject",
    contact_message_label: "Message",
    contact_submit_btn: "SUBMIT MESSAGE",
    contact_submitting_btn: "SUBMITTING...",
    contact_success_msg: "Your message has been sent successfully. We will get back to you soon!",
    contact_error_prefix: "Something went wrong. Please try again.",
    contact_response_time_title: "Response Time",
    contact_response_time_desc: "We check messages daily and usually reply within a day.",
    contact_availability_title: "Availability",
    contact_availability_desc: "CorpToolset is accessible globally.",
    contact_legal_privacy_title: "Legal & Privacy",
    contact_legal_privacy_desc: "Requests are reviewed according to applicable industry standards.",
    legal: "Legal",
    nav_resources: "Resources",
    nav_cookies: "Cookies",
    cat_text: "Text Utilities",
    cat_financial: "Financial & Business",
    cat_security: "Calculators & Security",
    contact_name_placeholder: "e.g. John Doe",
    contact_email_placeholder: "e.g. support@corptoolset.com",
    contact_subject_general: "General Inquiry",
    contact_subject_business: "Business / Partnership",
    contact_subject_legal: "Copyright / Content Issue",
    contact_subject_tech: "Technical Issue",
    contact_message_placeholder: "Describe the specific issue, unexpected output, or tool request here...",
    explore_ecosystem_pre: "Browse the",
    explore_ecosystem_highlight: "Tool Directory",
    trending_tools_title: "Trending Search Tools",
    sitemap_desc: "Browse all tools and articles in our comprehensive sitemap.",
    node_decommissioned: "Page Not Found",
    "404_desc": "The requested utility or page is currently unavailable. Please return to our homepage to locate a functional tool."
};




